/**
 * What steps back when the floating header draws in (FloatingHeader publishes
 * `data-compact` on the `group/header`): an element wrapped in this collapses
 * its width to nothing and fades, on the house spring. Pair it with a
 * `max-w-[…]` sized to the element's own content — the transition runs between
 * that and zero.
 */
export const HEADER_FOLD =
  'overflow-hidden transition-[max-width,opacity] duration-[var(--rt-spring-ms)] ease-[var(--rt-ease-spring)] '
  + 'motion-reduce:transition-none group-data-[compact=true]/header:max-w-0 group-data-[compact=true]/header:opacity-0';
